import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    downloaded: string;
    uploaded: string;
    partialUploaded: (uploaded: number, total: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status label when download is complete */
            downloaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscodeCompleteJobStatus.downloaded?c=6bh09trmjs1p", defaultMessage: "Downloaded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when upload is complete */
            uploaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "TranscodeCompleteJobStatus.uploaded?c=1os5hmwiups3e", defaultMessage: "Uploaded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status showing partial upload progress */
            partialUploaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (uploaded: number, total: number): string => __intl__.intl().formatMessage({ id: "TranscodeCompleteJobStatus.partialUploaded?c=1lrfuwh5fnm5b", defaultMessage: "Uploaded {uploaded, number} out of {total, number}" }, { uploaded: uploaded, total: total }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
